import script from "./contract-detail.vue?vue&type=script&lang=ts&setup=true"
export * from "./contract-detail.vue?vue&type=script&lang=ts&setup=true"

import "./contract-detail.vue?vue&type=style&index=0&id=3214a8be&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3214a8be"]])

export default __exports__